import blank from '../experiments/Blank.logo';
import ModelMolecules from '../experiments/ModelMolecules.logo';
import BasicBoard from '../experiments/BasicBoard.logo';
import Motion from '../experiments/Motion.logo';
import LightShow from '../experiments/LightShow.logo';
import Position from '../experiments/Position.logo';
import Packets from '../experiments/PacketsNew.logo';
import IntroToSensors from '../experiments/IntroSensors.logo';
import FMA from '../experiments/FMA.logo';
import NightLight from '../experiments/NightLight.logo';
import NightLightCheck from '../experiments/NightLightCheck.logo';
import WinterCoat from '../experiments/WinterCoat.logo';
import LightShowNoBoard from '../experiments/LightShowNoBoard.logo';
import Rover from '../experiments/Rover.logo';
import LightPackets from '../experiments/LightPackets.logo';
import MultiPlot from '../experiments/MultiPlot.logo';
import Lights from '../experiments/Lights.logo';
import Temperature from '../experiments/TempSTEMACES.logo';

export const experimentsList = [
    {
        name: "Blank",
        code: blank,
        view: 'main'
    },
    {
        name:"Light Show",
        code: LightShow,
        view: 'data'
    },
    {
        name:"Light Show (No Board)",
        code: LightShowNoBoard,
        view: 'main'
    },
    {
        name: "Intro to Sensors",
        code: IntroToSensors,
        view: 'data'
    },

    {
        name: "Night Light Setup",
        code: NightLightCheck,
        view: 'data'
    },
    {
        name: "Night Light",
        code: NightLight,
        view: 'data'
    },
    {
        name: "Winter Coat",
        code: WinterCoat,
        view: 'data'
    },
    {
        name:"Position",
        code: Position,
        view: 'motion'
    },
    {
        name: "Velocity",
        code: Motion,
        view: 'motion'
    },
    {
        name: "Light and Temperature",
        code: LightPackets,
        view: 'data'
    },
    {
        name: "(DEV) Light",
        code: Lights,
        view: 'data'
    },
    {
        name: "(DEV) Temperature",
        code: Temperature,
        view: 'data'
    },
//     {
//         name: "(DEV) Force & Motion",
//         code: FMA,
//         view: 'motion'
//     },
//     {
//         name: "(DEV) Rover",
//         code: Rover,
//         view: 'main'
//     },
//     {
//         name: "(DEV) MultiPlot",
//         code: MultiPlot,
//         view: 'data'
//     },
];